export enum UserMultiplayerSessionState {
    Joining = "Joining",
    InSession = "InSession",
    Leaving = "Leaving",
}